<div class="image" (click)="previewImage(params.data.ImageUrl)">
  <img [src]="params.data.ImageUrl" />
</div>
